import { Box } from '@primer/react';
import { useScrollReveal } from '../hooks/useScrollReveal';

const hiddenTransforms = {
  up: (distance) => `translateY(${distance}px)`,
  left: (distance) => `translateX(-${distance}px)`,
  right: (distance) => `translateX(${distance}px)`,
};

function Reveal({ children, delay = 0, distance = 32, direction = 'up', sx = {} }) {
  const [ref, inView] = useScrollReveal();

  return (
    <Box
      ref={ref}
      sx={{
        opacity: inView ? 1 : 0,
        transform: inView ? 'translate(0, 0)' : hiddenTransforms[direction](distance),
        transition: `opacity 0.8s ease-out ${delay}s, transform 0.8s ease-out ${delay}s`,
        ...sx,
      }}
    >
      {children}
    </Box>
  );
}

export default Reveal;
